module.exports = __webpack_public_path__ + "img/neck.85fe3522.svg";